exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td.textcolor\r\n{\r\n    color: red;\r\n}\r\n.squeezebox .sb-item {\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .squeezebox .sb-item .sb-item-body {\r\n    height: 0;\r\n    overflow: hidden;\r\n    transition: 0.5s height;\r\n  }\r\n  .button-padding{\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/view-shipment-details/view-shipment-details.component.css
// module id = ../../../../../src/app/logistics-operations/view-shipment-details/view-shipment-details.component.css
// module chunks = main